/**
 * We use this key as part of the query key to identify our data queries
 */ export const DATA_QUERY_KEY = 'DataQuery';
/**
 * We use this key to identify the 'DataQuery' plugin. Used in getPlugin.
 */ export const DATA_QUERY_PLUGIN_KEY = 'DataQuery';
// Leveraging a Record here to ensure we keep this list up-to-date because typescript will require
// all keys of the union are listed. There unfortunately isn't built-in support for doing something
// similar with arrays. We then get the actual array we want below by using Object.keys on this
// record.
const SUPPORTED_DATA_TYPES_RECORD = {
    HeatMap: true,
    SingleValue: true,
    SingleValueTimeSeries: true,
    Table: true,
    TimeSeries: true
};
export const SUPPORTED_DATA_TYPES = Object.keys(SUPPORTED_DATA_TYPES_RECORD);

//# sourceMappingURL=query.js.map